export default [
    '24 24',
    '<path d="M18 8L22 12M22 12L18 16M22 12H9M15 4.20404C13.7252 3.43827 12.2452 3 10.6667 3C5.8802 3 2 7.02944 2 12C2 16.9706 5.8802 21 10.6667 21C12.2452 21 13.7252 20.5617 15 19.796" fill="none" stroke="url(#paint0_linear_1308_10382)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<defs>\n' +
    '<linearGradient id="paint0_linear_1308_10382" x1="33.5039" y1="18.0184" x2="3.50391" y2="18.0184" gradientUnits="userSpaceOnUse">\n' +
    '<stop stop-color="var(--p-icon-gradient-stop, currentColor)"/>\n' +
    '<stop offset="1" stop-color="var(--p-icon-gradient-start, currentColor)"/>\n' +
    '</linearGradient>',
]